import { Stack, Typography } from "@mui/material";
import VjustOverview from "./VjustOverview";
import VjustCostOverview from "./VjustCostOverview";
import { kaiTheme } from "../style/kaiTheme";

export default function FullAppOverview({ classes }) {
  return (
    <Stack spacing={4} marginTop={4}>
      {[
        {
          title: "Safety and Capacity",
          child: <VjustOverview classes={classes} />,
        },
        {
          title: "VJuST-C",
          child: <VjustCostOverview classes={classes} />,
        },
      ].map(({ title, subtitle, child }) => (
        <details key={title}>
          <summary style={{ cursor: "pointer" }}>
            <Typography sx={{ display: "inline" }} variant="h5">
              {title}
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: kaiTheme.kai_color_darkgrey,
                  marginLeft: "10px",
                }}
              >
                {subtitle}
              </span>
            </Typography>
          </summary>
          {child}
        </details>
      ))}
    </Stack>
  );
}
